import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

const hasBorder = (theme) => theme.list_border_bottom_height && theme.list_border_bottom_color

interface StyledListProps {
  theme: any;
}
export const StyledList = styled.div<StyledListProps>`
  &:not(:last-of-type) {
    ${({ theme }) =>
            hasBorder(theme) &&
            `border-bottom: ${pxToRem(theme.list_border_bottom_height)} solid ${theme.list_border_bottom_color} `}};
}
`

interface StyledButtonHalfProps {
  theme: any;
  $img: string;
  $borderRadius: string;
  $borderWidth: string;
}
export const StyledButtonHalf = styled.a<StyledButtonHalfProps>`
  display: block;
  background-image: url("${({ $img }) => $img}");
  background-size: cover;
  background-position: center center;
  text-align: ${({ theme }) => (theme.button_half_align_label_left && 'left') || 'center'};
  margin: 0 auto ${pxToRem(10)} auto;
  border-radius: ${({ $borderRadius }) => $borderRadius}%;
  border: ${({ $borderWidth }) => $borderWidth}px solid
    ${({ theme }) => theme.button_half_border_color || 'black'};
  width: 100%;

  &::after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }
`

interface StyledHalfContainerProps {
  theme: any;
}
export const StyledHalfContainer = styled.div<StyledHalfContainerProps>`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  margin: ${pxToRem(20)};

  a:last-of-type::before {
    content: '';
    display: block;
    margin-bottom: ${pxToRem(10)};
    ${({ theme }) =>
            theme.button_half_underline &&
            `border-bottom: ${pxToRem(theme.button_half_underline_height || 1)} solid ${
                    theme.button_half_underline_color || 'black'
            }`};
    ${({ theme }) =>
            theme.button_half_underline_width && `width: ${pxToRem(theme.button_half_underline_width)}`};
  }
`

const getFlex = (columns) => {
  switch (columns) {
    case '3':
      return '33%'
    case '4':
      return '25%'
    default:
      return '43%'
  }
}

interface StyledContainerItemProps {
  theme: any;
  $columns: string;
}
export const StyledContainerItem = styled.div<StyledContainerItemProps>`
  position: relative;
  flex-basis: ${({ $columns }) => getFlex($columns)};
  max-width: ${({ $columns, theme }) =>
          (theme.button_half_max_width && pxToRem(theme.button_half_max_width)) || getFlex($columns)};
  padding: ${pxToRem(10)};
  text-align: ${({ theme }) => (theme.button_half_align_label_left && 'left') || 'center'};

  span {
    ${({ theme }) => theme.button_half_font && `font-family: ${theme.button_half_font}`};
    font-weight: ${({ theme }) => theme.button_half_text_weight || '600'};
    font-size: ${({ theme }) => pxToRem(theme.button_half_text_size || 15)};
    word-break: break-word;
    ${({ theme }) => theme.button_half_text_color && `color: ${theme.button_half_text_color}`};
  }
`
